import { ServiceFetch } from '../service-fetch'

export default class PayrollSublistModel extends ServiceFetch {
    getPayrollSublistBy = (data) => this.authFetch({
        url: 'payroll-sublist/getPayrollSublistBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}